import { render } from "./PolicyView.vue?vue&type=template&id=36372d31&scoped=true"
import script from "./PolicyView.vue?vue&type=script&lang=js"
export * from "./PolicyView.vue?vue&type=script&lang=js"

import "./PolicyView.vue?vue&type=style&index=0&id=36372d31&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36372d31"]])

export default __exports__